import React from "react";
import { sanitySrcUrl } from "../../lib/libFunctions";
import { useParallaxInView } from "../../lib/hooks";
import { Section } from "../section/section.component";
import { Carousel } from "../carousel-css-cross-fade/carousel-css-crossfade";
import { analyticsModuleAttributes } from "../../lib/analytics-content.mjs";
import {
  base,
  imageStyles,
  containers,
  motion,
  useScroll,
  useSpring,
  useInView,
  animations,
} from "../../styles/base/_allBase.styles";

const { InsetDiv } = containers;
const { ImgCover } = imageStyles;
const { fadeInOutAnimation } = animations;

function InsetCarouselSection({ imageArray, ariaLabel = "Image gallery", moduleId = "inset-carousel" }) {
  return (
    <Section
      cursorsize={"small"}
      size={"auto"}
      {...analyticsModuleAttributes({ _key: moduleId }, "image_carousel", undefined, ariaLabel)}
    >
      <InsetDiv setvisible="true">
        <Carousel ariaLabel={ariaLabel} analyticsModuleId={moduleId}>
          {imageArray.map((image, i) => {
            return (
              <motion.div
                key={image._key || image.asset?._ref || i}
                cycle={true.toString()}
                {...fadeInOutAnimation}
              >
                <ImgCover
                  src={sanitySrcUrl(image)}
                  alt={image.alt}
                  fill
                />
              </motion.div>
            );
          })}
        </Carousel>
      </InsetDiv>
    </Section>
  );
}

export { InsetCarouselSection };
